'use strict';
const mmWidgets = require('../../widgets/mm-widgets');
require('../../widgets/email-authentication-widget');
require('../../widgets/oauth-authentication-widget');
require('../../widgets/suggested-email-widget');
require('../../widgets/user-profile-widget');
require('../../widgets/use-google-email-widget');

module.exports = function authenticationAWSWidgets(authenticationModels, optional) {
	if (!authenticationModels || !authenticationModels.oneTimePasswordAuthenticator || !authenticationModels.googleAuthenticator || !authenticationModels.microsoftAuthenticator || !authenticationModels.authenticationModel) {
		throw 'invalid-args';
	}
	mmWidgets('[data-mm-role~="use-google-email-dialog"]').useGoogleEmailWidget(authenticationModels.googleAuthenticator);
	mmWidgets('[data-mm-role~="email-authentication-dialog"]').emailAuthenticationWidget(authenticationModels.oneTimePasswordAuthenticator);
	mmWidgets('[data-mm-role~="google-authentication-dialog"]').oauthAuthenticationWidget(authenticationModels.googleAuthenticator);
	mmWidgets('[data-mm-role~="microsoft-authentication-dialog"]').oauthAuthenticationWidget(authenticationModels.microsoftAuthenticator);

	mmWidgets('[data-mm-role~="suggested-email"]').suggestedEmailWidget(authenticationModels.authenticationModel, optional);
	mmWidgets('[data-mm-user-profile]').userProfileWidget(authenticationModels.authenticationModel);
};
